import { env } from 'env';

export const log = (message?: any, ...optionalParams: any[]) => {
  if (env.env === 'production') return;

  console.log(message, ...optionalParams);
};
